import { useEffect, useState } from 'react';

const REFERENCE_SCREEN_HEIGHT = 1080;
const REFERENCE_CONTAINER_HEIGHT = 650;

const REFERENCE_RATIO =
  REFERENCE_CONTAINER_HEIGHT / REFERENCE_SCREEN_HEIGHT;

// function adjust(value: number, min: number, max: number) {
//   // Clamp the value between min and max
//   return Math.max(min, Math.min(max, value));
// }

export function useZoomNormalization() {
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const calculate = () => {
      const container = document.getElementById(
        'stats-and-info-list-container'
      );

      if (!container) {
        setScale(1);
        return;
      }

      // Use offsetHeight to get the layout size (before any CSS transforms)
      // offsetHeight gives us the size in the layout, unaffected by CSS transforms
      const containerHeight = container.offsetHeight;
      const screenHeight = window.innerHeight;

      if (!containerHeight || !screenHeight || containerHeight <= 0 || screenHeight <= 0) {
        setScale(1);
        return;
      }

      // Calculate target height based on reference ratio
      const targetHeight = screenHeight * REFERENCE_RATIO;

      // Calculate scale needed: target / current
      // If container is too big (635px), target is smaller (352px), scale < 1 to shrink
      // If container is too small, target is bigger, scale > 1 to grow
      const rawScale = Math.round((targetHeight / containerHeight) * 10) / 10;

      let normalizedScale = 1 / rawScale;

      if (normalizedScale <= 1.2 && normalizedScale >= 0.9) {
        normalizedScale = 1;
      }

      // Update state so zoomLevel and inverseScale are correct
      setScale(normalizedScale);

      // Optional CSS vars
      document.documentElement.style.setProperty(
        '--layout-scale',
        normalizedScale.toString()
      );
      document.documentElement.style.setProperty(
        '--game-scale',
        (1 / normalizedScale).toString()
      );

    };

    calculate();
    const t = setTimeout(calculate, 100);

    window.addEventListener('resize', calculate);

    return () => {
      clearTimeout(t);
      window.removeEventListener('resize', calculate);
    };
  }, []);

  return {
    zoomLevel: scale,
    inverseScale: 1 / scale,
  };
}
